module.exports = __webpack_public_path__ + "img/nevs_level_CEn.58c5e077.png";